import UserAvatar from '@/components/UserAvatar';
import {mapState} from 'vuex';
import moment from "moment";

export default {
  name: "ReactionListModal",
  components: {
    UserAvatar
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default: () => {
      }
    },
    items: {
      type: Object,
      default: () => {}
    },
    reactionIcons: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      users: state => state.Chat.uxDocs
    })
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(new Date(value)).format('ddd, MMM DD');
      } else {
        return 'NaN'
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.populateItems();
      }
      this.showModal = val;
    }
  },
  created() {
    this.showModal = this.show;
  },
  data() {
    return {
      reactions: [],
      showModal: false,
    }
  },
  methods: {
    hideModal() {
      this.showModal = false;
      this.hide();
    },
    populateItems() {
      this.reactions = [];
      for (const item in this.items) {
        let user = this.users[item] || { first_name: 'Unknown', last_name: 'User' };
        for (const reaction in this.items[item]) {
          const val = this.items[item][reaction];
          if (val) {
            const date = val && typeof val.toDate === 'function' ? val.toDate() : (val instanceof Date ? val : new Date(val));
            this.reactions.push({
              reaction: this.reactionIcons[reaction],
              user: user,
              date: date
            })
          }
        }
      }

      this.reactions = this.reactions
        .sort((a, b) => a.date.getTime() < b.date.getTime() ? 1 : -1 );
    }
  }
}